import mutationsTypes from '@/store/mutationTypes'
import axios from 'axios'
import api from '@/config/api'
import apiMock from '@/config/apiMock'
import { commonUtil } from '@/util'
import requestLoadingList from './request/requestLoadingList'
import requestLoadingEdit from './request/requestLoadingEdit'
import requestLoadingRegister from './request/requestLoadingRegister'

const Actions = {
  // LO01 入庫履歴一覧取得
  getLoadingListFromApi: async (
    { state, dispatch, commit, getters, rootGetters, rootState },
    params
  ) => {
    const requestList = requestLoadingList
    let req = params
    // 入庫履歴画面の時のみ
    if ('pageType' in params && params.pageType === 'LoadingHistory') {
      req = requestList.request.createRequest(params.searchParameter)
    }

    return await axios
      // .get(apiMock.LOADING_LIST)
      .get(api.LOADING_LIST, { params: req })
      .then((response) => {
        const path = mutationsTypes.LOADING_SET_LOADING_LIST
        commit(path, response.data.data)

        // ページャーをセット
        const pagePath = mutationsTypes.UI_SET_PAGE_COUNT
        const pageCount = commonUtil.getPageCount(
          response.data.meta.totalRows,
          response.data.meta.perPage
        )
        commit(
          `UI/${pagePath}`,
          { length: pageCount, key: 'orderLoading' },
          { root: true }
        )

        const getData = getters.getLoadingListFromState
        const ret = commonUtil.afterApiSuccessProcess(response, getData)
        return ret
      })
      .catch((error) => {
        // commonErrorControl(error.response)
        commonUtil.afterApiFailProcess(error.response)
        return false
      })
  },
  // LO04 入庫微調整
  editLoading: async (
    { state, dispatch, commit, getters, rootGetters, rootState },
    params
  ) => {
    const req = requestLoadingEdit.request.createRequest(params)

    return await axios
      // .get(apiMock.LOADING_DETAIL_EDIT)
      .patch(`${api.LOADING_DETAIL_EDIT}/${params.id}`, req)
      .then((response) => {
        return true
      })
      .catch((error) => {
        // commonErrorControl(error.response)
        commonUtil.afterApiFailProcess(error.response)
        return false
      })
  },
  // OH03 入庫操作登録
  registerLoading: async (
    { state, dispatch, commit, getters, rootGetters, rootState },
    params
  ) => {
    const req = requestLoadingRegister.request.createRequest(params)

    return await axios
      // .get(apiMock.LOADING_DETAIL_EDIT)
      .post(`${api.LOADING_DETAIL_EDIT}/${params.orderId}`, req)
      .then((response) => {
        return true
      })
      .catch((error) => {
        // commonErrorControl(error.response)
        commonUtil.afterApiFailProcess(error.response)

        return false
      })
  },
  // LO02 入庫キャンセル
  cancelLoading: async (
    { state, dispatch, commit, getters, rootGetters, rootState },
    params
  ) => {
    return await axios
      // .get(apiMock.LOADING_CANCEL)
      .patch(`${api.LOADING_CANCEL}/${params.id}`)
      .then((response) => {
        const path = mutationsTypes.LOADING_CANCEL_FLG
        commit(path, true)
        return true
      })
      .catch((error) => {
        // commonErrorControl(error.response)
        commonUtil.afterApiFailProcess(error.response)
        return false
      })
      .finally(() => {
        const path = mutationsTypes.LOADING_CANCEL_FLG
        commit(path, false)
      })
  }
}

export default Actions
